import { GET_HOURS } from './const';
import labels from '../i18n';

export default (lang) => ({
  type: GET_HOURS,
  payload: [
    {
      label: labels[lang].fullTime,
      value: 'fulltime',
    },
    {
      label: labels[lang].partTime,
      value: 'parttime',
    },
  ],
});
